import { dataHooks } from '@wix/data-hooks'

export const optionDataHooks = dataHooks<{
  img: {}
  label: {}
  description: {}
  btn: {}
}>('option')
